var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[
        'tooltip-container',
        {
            top: _vm.position === 'top',
            right: _vm.position === 'right',
            bottom: _vm.position === 'bottom',
            left: _vm.position === 'left',
            shown: _vm.shown
        }
    ]},[_c('font-awesome-icon',{class:['tooltip-icon', _vm.classes],attrs:{"icon":_vm.icon}}),_c('span',{staticClass:"tooltip-text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }